"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatShippingAddress = void 0;
const formatShippingAddress = (shipping) => {
    const streetLine = shipping.address?.split(",")[0]?.trim() || shipping.fullName || null;
    const regionPart = [shipping.region, shipping.country, shipping.postalCode].filter(Boolean).join(" ");
    const cityLine = [shipping.city, regionPart].filter(Boolean).join(", ") || null;
    return { streetLine, cityLine };
};
exports.formatShippingAddress = formatShippingAddress;
